/**
 * Internal dependencies
 */
import { applyEdits } from 'state/utils';
import isEditedLocationDirty from './is-edited-location-dirty';
import getLocation from './get-location';
import getEdits from './get-edits';

export default (state, id) => {

    id = !id ? "" : id;

    if (isEditedLocationDirty(state, id || "")) {
        let location = getLocation(state, id);
        let edits = getEdits(state, id);
        location = applyEdits(location, edits);
        return location;
    }

    return getLocation(state, id);
};